import Grid from '@mui/material/Grid2';
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import TripRateCalculationViewModel from '../ViewModels/TripRateCalculationViewModel';

interface IProps {
    calculate: (start: number, end: number) => void;
    tripRate: TripRateCalculationViewModel | null;
}

export default function SurveyPeriod(props: IProps) {
    const [startPeriods, setStartPeriods] = useState<number[]>([]);
    const [endPeriods, setEndPeriods] = useState<number[]>([]);
    const [start, setStart] = useState<number>(0);
    const [end, setEnd] = useState<number>(23);

    const handleChange = (event) => {
        var value = Number.parseInt(event.target.value as string)

        switch (event.target.name) {
            case "startPeriod":
                setStart(value)
                break;
            case "endPeriod":
                setEnd(value)
                break;
        }
    }

    useEffect(() => {
        let min = start;
        let max = end;
        if (props.tripRate) {
            let peaks = [props.tripRate.arrivalsPeak, props.tripRate.departuresPeak, props.tripRate.totalsPeak];
            for (var peak of peaks) {
                const index = parseInt(peak?.substring(0, 2) ?? '0');
                if (!isNaN(index)) {
                    if (index > min) {
                        min = index;
                    }
                    if (index < max) {
                        max = index;
                    }
                }
            }
        }
        let startPeriods: number[] = []
        for (var i = 0; i <= max; i++) {
            startPeriods.push(i)
        }

        let endPeriods: number[] = [];
        for (var i = min; i <= 23; i++) {
            endPeriods.push(i)
        }

        setStartPeriods(startPeriods)
        setEndPeriods(endPeriods)
    }, [start, end, props.tripRate])

    const submit = () => {
        props.calculate(start, end)
    }

    return (
        <Grid container alignItems="center">
            <Grid size={12}>
                <Typography>Time Slice</Typography>
            </Grid>
            {props.tripRate &&
                <>
                    <Grid size={4}>
                        <TextField
                            select
                            label="Start"
                            name="startPeriod"
                            value={start}
                            margin="dense"
                            onChange={handleChange}>
                            {startPeriods.map((x: number) => {
                                return <MenuItem key={x} value={x}>
                                    {("0" + x + ":00").slice(-5)}
                                </MenuItem>;
                            }
                            )}
                        </TextField>
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            select
                            label="End"
                            name="endPeriod"
                            value={end}
                            margin="dense"
                            onChange={handleChange}>
                            {endPeriods.map((x: number) => {
                                return <MenuItem key={x} value={x}>
                                    {("0" + (x + 1) + ":00").slice(-5)}
                                </MenuItem>;
                            }
                            )}
                        </TextField>
                    </Grid>
                    <Grid size={4}>
                        <Button onClick={submit}>Calculate</Button>
                    </Grid>
                </>
            }
        </Grid>
    )
}
